// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__YlsNo","Header":"Pricing_Header__muYFi"};